<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="saldosPorLocalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Saldos por Local</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>{{ dados.st_estoque_item }}</div>
                                <div>{{ dados.st_unidade_estoque }}</div>
                            </div>

                            <div v-if="dados.num_lote">Lote: {{ dados.num_lote }}</div>

                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(saldo, ilx) in dados.saldos" :key="ilx">
                                    <div>
                                        {{ saldo.local.st_estoque_local }}
                                        <span class="badge badge-light ml-1" v-if="saldo.local.unidade_operacao && saldo.local.unidade_operacao.st_sigla">
                                            {{ saldo.local.unidade_operacao.st_sigla }}
                                        </span>
                                    </div>
                                    <div>
                                        {{ saldo.qtd }}
                                    </div>
                                </li>
                            </ul>
                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
//import _ from 'lodash';
import $ from 'jquery';
//import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data () { 
        return { 
            dados: null, 
        }
    },

    components: { 
        AzEmptyState,
    },

    methods: { 
        abrir(item) { 
            this.dados = null;

            $('#saldosPorLocalModal').modal('show');

            this.$util.load(this, { 
                service: 'estoque_items',
                func: 'show',
                parms: { 
                    id: item.id_estoque_item,
                    num_lote: item.st_lote, 
                    saldos_por_local: true, 
                },
                loadTo: res => { 
                    res.num_lote = item.st_lote;
                    this.dados = res;
                }
            })
        }
    }
}
</script>

